@if (visible()) {
  <div class="open-in-app-banner" role="dialog" aria-live="polite">
    <span class="open-in-app-banner__text">Continue no app Givo para a melhor experiência.</span>
    <div class="open-in-app-banner__actions">
      <button type="button" class="open-in-app-banner__open" (click)="openApp()">Abrir no app</button>
      <button type="button" class="open-in-app-banner__dismiss" (click)="dismiss()" aria-label="Fechar">✕</button>
    </div>
  </div>
}
